export default "__VITE_ASSET__DVnaU4pF__"